import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import Sidebar from "components/Sidebar/Sidebar";
import { Spinner } from "components/Spinner";
import { useLayout } from "context/layout/layout";
import React, { useEffect, useState } from "react";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import config from "services/config";
import { useLocation, useNavigate } from "react-router-dom";
import RateReviewIcon from "@mui/icons-material/RateReview";

export const AddExpense = () => {
  return (
    <>
      <Sidebar />
      <Wrapper>
        <AddProductSettings />
      </Wrapper>
    </>
  );
};

const Wrapper = ({ children }) => {
  return (
    <div className="relative h-full" style={{ marginLeft: 200 }}>
      <div className="relative h-full" style={{ paddingBottom: 95 }}></div>
      <div className=" mx-auto w-full -m-24" style={{ height: "100vh" }}>
        <div className="flex flex-wrap h-full">
          <div className="w-full h-full">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default function AddProductSettings() {
  const location = useLocation();
  const navigate = useNavigate();
  const layout = useLayout();

  const [loading, setLoading] = useState(false);
  const [salesman, setSalesman] = useState([]);
  const [withdraw, setWithdraw] = useState({
    staff: { name: "" },
    amount: 0,
    comments: "",
    shiftId: "",
  });

  useEffect(() => {
    if (!location.state.shiftId) {
      navigate("/daily/gym");
    }

    setWithdraw({
      ...withdraw,
      shiftId: location.state.shiftId,
    });
    // eslint-disable-next-line
  }, [location]);

  // Get the salesman
  useEffect(() => {
    axios.get(`${config.url}/users/showall`).then(({ data }) => {
      let salesman = data.map((user) => {
        return {
          ...user,
          label: user.name,
        };
      });
      console.log(salesman);
      setSalesman(salesman);
    });
    // eslint-disable-next-line
  }, []);

  const handleSubmit = () => {
    setLoading(true);

    let cash = location.state.cashAmount;

    if (cash < withdraw.amount) {
      return layout.errorAlert({
        message: `El gasto no puede ser mayor al efectivo disponible de $${cash}`,
      });
    }
    axios
      .post(
        `${config.url}/expenses/create`,
        {
          staff: withdraw.staff._id,
          amount: withdraw.amount,
          comments: withdraw.comments,
          shiftId: withdraw.shiftId,
        },
        {
          headers: {
            "Content-type": "application/json",
          },
        }
      )
      .then((res) => {
        setLoading(false);
        navigate(-1);
        console.log(res);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };

  const handleStaff = (e, v) => {
    setWithdraw({
      ...withdraw,
      staff: v,
    });
  };

  return (
    <>
      {loading && <Spinner />}

      <div
        className="relative h-full flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
        style={{ backgroundColor: "rgb(17, 24, 39)" }}
      >
        <div
          className="rounded-t  mb-0 py-6 "
          style={{ backgroundColor: "rgb(17, 24, 39)", paddingLeft: 40 }}
        >
          <div className="text-center flex items-center">
            <AddShoppingCartIcon sx={{ marginRight: 2, color: "#ccc" }} />
            <h6 className="text-white text-xl">
              Ingresar un nuevo gasto al turno {location.state.shiftId}
            </h6>
          </div>
        </div>

        <div className="px-4 lg:px-10 pt-0">
          <form>
            <div className="flex  pt-2">
              <div className="flex items-center">
                <PersonSearchIcon
                  sx={{
                    color: "#fff",
                    fontSize: 29,
                    marginRight: 3,
                    transform: "translate(18px, 0)",
                  }}
                />
              </div>
              <div className="w-full  px-4">
                <div className="relative w-full mb-3">
                  <label style={{ fontSize: 12, color: "#cbd5e1" }}>
                    Ingresa el staff que gestiona el gasto
                  </label>
                  <Autocomplete
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Selecciona el staff"
                      />
                    )}
                    clearIcon={false}
                    options={salesman}
                    value={withdraw.staff}
                    inputValue={withdraw.staff.name}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option._id}>
                          {option.name}
                        </li>
                      );
                    }}
                    sx={{
                      padding: 0,
                      border: "none",
                      marginRight: 2,
                      backgroundColor: "#cbd5e1",
                    }}
                    onChange={handleStaff}
                    getOptionLabel={(option) => option.name}
                    type="text"
                    className="border-0  placeholder-black text-blueGray-600  rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  />
                </div>
              </div>
              <div className="w-full  px-4">
                <div className="relative w-full mb-3">
                  <label style={{ fontSize: 12, color: "#cbd5e1" }}>
                    Fecha de hoy
                  </label>
                  <TextField
                    disabled
                    className="border-0  placeholder-black text-blueGray-600  rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                    sx={{
                      padding: 0,
                      border: "unset",
                      backgroundColor: "#cbd5e1",
                    }}
                    value={new Date().toLocaleDateString()}
                  />
                </div>
              </div>
              <div className="w-full  px-4">
                <div className="relative w-full mb-3">
                  <label style={{ fontSize: 12, color: "#cbd5e1" }}>
                    Ingresa el monto a gastar
                  </label>
                  <TextField
                    sx={{
                      padding: 0,
                      border: "none",
                      marginRight: 2,
                      backgroundColor: "#cbd5e1",
                    }}
                    value={withdraw.amount}
                    onChange={({ target }) =>
                      setWithdraw({ ...withdraw, amount: target.value })
                    }
                    placeholder="Monto Ej: 9000"
                    type="number"
                    className="border-0  placeholder-black text-blueGray-600  rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  />
                </div>
              </div>
            </div>
            <div className="flex  pt-2">
              <div className="flex items-center">
                <RateReviewIcon
                  sx={{
                    color: "#fff",
                    fontSize: 29,
                    marginRight: 3,
                    transform: "translate(18px, 0)",
                  }}
                />
              </div>
              <div className="w-full  px-4">
                <div className="relative w-full mb-3">
                  <label style={{ fontSize: 12, color: "#cbd5e1" }}>
                    Ingresa comentarios u observaciones
                  </label>
                  <TextField
                    sx={{
                      padding: 0,
                      border: "none",
                      marginRight: 2,
                      backgroundColor: "#cbd5e1",
                    }}
                    value={withdraw.comments}
                    onChange={({ target }) => {
                      setWithdraw({ ...withdraw, comments: target.value });
                    }}
                    placeholder="Observaciones"
                    type="text"
                    className="border-0  placeholder-black text-blueGray-600  rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                  />
                </div>
              </div>
            </div>

            <hr className="mt-6 mb-6 border-b-1 border-blueGray-300" />
          </form>
        </div>

        <div
          className="flex-auto px-4 lg:px-10 pt-0"
          style={{ backgroundColor: "rgb(17, 24, 39)" }}
        >
          <form>
            <div className="w-full" style={{ transform: "translateX(76px)" }}>
              <button
                onClick={handleSubmit}
                style={{ height: 50, width: "46%" }}
                className=" bg-lightBlue-500  text-white active:bg-lightBlue-600 font-bold uppercase text-xs rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                type="button"
              >
                Publicar
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
